import { render, staticRenderFns } from "./PasswordResetRequest.vue?vue&type=template&id=16653452&scoped=true&"
import script from "./PasswordResetRequest.vue?vue&type=script&lang=js&"
export * from "./PasswordResetRequest.vue?vue&type=script&lang=js&"
import style0 from "./PasswordResetRequest.vue?vue&type=style&index=0&id=16653452&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16653452",
  null
  
)

export default component.exports